import { TooltipPosition } from '../model/types';

export const getTooltipArrowSize = (position: TooltipPosition) => {
  const [min, max] = [8, 14];

  if (
    position === 'top' ||
    position === 'bottom' ||
    position === 'topLeft' ||
    position === 'topRight' ||
    position === 'bottomLeft' ||
    position === 'bottomRight'
  ) {
    return { width: max, height: min };
  }

  return { width: min, height: max };
};

export const getTooltipArrowPoints = (width: number, height: number, position: TooltipPosition) => {
  const points: Record<TooltipPosition, string> = {
    left: `0,0 ${width},${height / 2} 0,${height}`,
    right: `${width},${height} 0,${height / 2} ${width},0`,

    top: `0,0 ${width / 2},${height} ${width},0`,
    bottom: `0,${height} ${width / 2},0 ${width},${height}`,

    topLeft: `0,0 ${width / 2},${height} ${width},0`,
    topRight: `0,0 ${width / 2},${height} ${width},0`,
    bottomLeft: `0,${height} ${width / 2},0 ${width},${height}`,
    bottomRight: `0,${height} ${width / 2},0 ${width},${height}`,
  };

  return points[position];
};
